export default __webpack_public_path__ + "static/Open-Sans-8ed086d46abbd59e97723195e62f15e1.woff";